import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';

import { Flex } from '../Flex';

import styles from './Progress.module.scss';

export interface IProgressProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    progress: number;
}

export const Progress = ({ progress, className, ...props }: IProgressProps) => {
    return (
        <Flex className={classNames(styles.progress, className)} {...props}>
            <motion.div
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.5 }}
                className={styles.indicator}
            ></motion.div>
        </Flex>
    );
};
